import { type FC, type ReactNode } from "react";

import styled from "@emotion/styled";
import { Colors, Fonts } from "@snapchat/snap-design-system";

const Title = styled.h3`
    ${Fonts.Heading.H500}
    margin-bottom: 2px;
`;

const SubTitle = styled.p`
    ${Fonts.Heading.H700}
    color: ${Colors.Gray.V300};
`;

interface ContentHeaderProps {
    title: ReactNode;
    subtitle?: ReactNode;
    className?: string;
}

export const ContentHeader: FC<ContentHeaderProps> = ({ title, subtitle, className }) => (
    <header className={className}>
        <Title>{title}</Title>
        {subtitle && <SubTitle>{subtitle}</SubTitle>}
    </header>
);
